import { ApiAbstract } from '../abstract';
import { ValueType } from '../../../types/value';

export class ApiValue extends ApiAbstract<any, ValueType> {}
